import {ARHIJoinState} from '../rootReducer';

export const getJoinDetails = (state: ARHIJoinState) => state.join;
export const getPolicyNumber = (state: ARHIJoinState) => getJoinDetails(state).policyNumber;
export const getJoinId = (state: ARHIJoinState) => getJoinDetails(state).joinId;
export const getJoinError = (state: ARHIJoinState) => getJoinDetails(state).joinError;
export const getKycUrl = (state: ARHIJoinState) => getJoinDetails(state).kycUrl;
export const getKycStatus = (state: ARHIJoinState) => getJoinDetails(state).kycStatus;
